import React from 'react'

const NotAuthorized = () => {
    return (
        <div className={'center top-padding'}>
			We're sorry, but you do not have access to this content.
        </div>
    )
}

export default NotAuthorized;
